import { TabOption, Tabs } from 'src/components/molecules/DataBox/Tabs';
import { IS_DEV } from 'src/constants';

export type TrendsType = 'trends' | 'pacingView' | 'flightView';

const tabs: Array<TabOption<TrendsType>> = [
  {
    label: 'Trends',
    value: 'trends',
  },
];

if (IS_DEV) {
  tabs.push(
    {
      label: 'Pacing View',
      value: 'pacingView',
    },
    {
      label: 'Flighting View',
      value: 'flightView',
    },
  );
}

export type TrendTabsProps = {
  selectedTab: TrendsType;
  onSelect: (value: TrendsType) => void;
};

export const TrendTabs: React.FC<TrendTabsProps> = ({
  onSelect,
  selectedTab,
}) => {
  return <Tabs options={tabs} onSelect={onSelect} selectedTab={selectedTab} />;
};
